import React from 'react';
import Aux from '../../hoc/Aux';
import useCustomHtmlTranslation from '../../hooks/useCustomHtmlTranslation';

const textDatenschutz = (props) => {

  const ht = useCustomHtmlTranslation();

  return (
  <Aux>
    <h1>{ ht('content.datenschutz.headline') }</h1><br />
    { ht('content.datenschutz') }
  </Aux>
  )
};

export default textDatenschutz;



// WEBPACK FOOTER //
// ./src/components/Shared/TextDatenschutz.js